<template>
  <div :class="$style.container">
    <simple-button
      :fluid="false"
      :disabled="isDisabledDecrement"
      variant="outlined"
      @click="decrement"
    >
      <base-icon name="basic_minus" :size="16" />
    </simple-button>
    <div :class="$style.number">
      {{ displayCounter }}
    </div>
    <simple-button
      :fluid="false"
      :disabled="isDisabledIncrement"
      variant="outlined"
      @click="increment"
    >
      <base-icon name="basic_plus" :size="16" />
    </simple-button>
  </div>
</template>

<script>
import BaseIcon from 'atoms/base/BaseIcon';
import SimpleButton from 'molecules/common/SimpleButton';

export default {
  name: 'NumberCounter',
  components: {
    BaseIcon,
    SimpleButton,
  },
  props: {
    count: {
      type: Number,
      default: 0,
    },
    countBundle: {
      type: Number,
      default: 0,
    },
    countPerPayment: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      counter: 1,
    };
  },
  computed: {
    isCountBundle() {
      return this.$validate.isPositiveNumber(this.countBundle);
    },
    isDisabledDecrement() {
      return this.isCountBundle || this.counter === 1;
    },
    isDisabledIncrement() {
      return this.isCountBundle || this.counter === this.limit;
    },
    displayCounter() {
      if (this.isCountBundle) {
        return this.countBundle;
      }

      return this.counter;
    },
    limit() {
      if (this.$validate.isPositiveNumber(this.count)) {
        if (this.$validate.isPositiveNumber(this.countPerPayment)) {
          return Math.min(this.count, this.countPerPayment);
        }

        return this.count;
      }

      return this.countPerPayment;
    },
  },
  methods: {
    increment() {
      if (this.isDisabledIncrement) {
        return;
      }

      this.counter++;
      this.$emit('update', this.counter);
    },
    decrement() {
      if (this.isDisabledDecrement) {
        return;
      }

      this.counter--;
      this.$emit('update', this.counter);
    },
  },
};
</script>

<style lang="sass" module>
  .container
    +flexbox
    +align-items(center)
    position: relative

  .increment
    +flexbox
    padding: 12px 18px
    background-color: #fff
    border: 4px solid #C7C7C7
    border-radius: 50px
    cursor: pointer

  .decrement
    +flexbox
    padding: 12px 18px
    background-color: #C7C7C7
    border: 4px solid #C7C7C7
    border-radius: 50px
    cursor: pointer

  .number
    +font-type(semi-bold, 18, 26)
    color: #212121
    min-width: 12px
    margin: 0 20px
</style>
